import { get, includes, filter } from 'lodash';

export const canAdministerClubComments = (state, clubId) =>
  get(state, `comments.canAdminister[${clubId}]`, false);
export const canAddCommentsAtClub = (state, clubId) =>
  get(state, `comments.canComment[${clubId}]`, false);

export const isLoadingComments = (state, clubId, mediaType, mediaId) => {
  const currentlyLoading = get(state, `comments.loadingComments[${clubId}]`, []);
  return includes(currentlyLoading, `${mediaType}-${mediaId}`);
};

export const isCheckingPermissions = (state, clubId) =>
  includes(get(state, 'comments.checkingPermissions', []), clubId);

export const isSubmittingComment = (state, clubId, mediaType, mediaId) => {
  const currentlySubmitting = get(state, `comments.currentlySubmittingTopLevelComments`, []);
  return includes(currentlySubmitting, `${clubId}-${mediaType}-${mediaId}`);
};

export const hasLoadedComments = (state, clubId, mediaType, mediaId) => {
  const previouslyLoaded = get(state, `comments.loadedComments[${clubId}]`, []);
  return includes(previouslyLoaded, `${mediaType}-${mediaId}`);
};

export const hasFailedToLoad = (state, clubId, mediaType, mediaId) => {
  const previouslyLoaded = get(state, `comments.loadingFailures[${clubId}]`, []);
  return includes(previouslyLoaded, `${mediaType}-${mediaId}`);
};

export const getComments = (state, clubId, mediaType, mediaId) =>
  filter(get(state, `comments.comments[${clubId}]`, []), {
    media_type: mediaType,
    media_id: mediaId,
  });
